import React, { useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles  from './useStyles'

const PasoUnoForm = () => {



    const classes = useStyles();
    const [value, setValue] = React.useState(new Date('2014-08-18T21:11:54'));

    const handleChange = (event) => {
        setAseguradora(event.target.value);
    };

    const handleChangeGenero = (event) => {
      setGenero(event.target.value);
   
  };
  const handleChangeSexo = (event) => {
    setSexo(event.target.value);
    
    };

    const handleChangeRegion = (event) => {
      setRegion(event.target.value);
    };
    const handleChangeComuna = (event) => {
      setComuna(event.target.value);
    };
  
    const [genero, setGenero] = React.useState('');
    const [aseguradora, setAseguradora] = React.useState('');
    const [subTitulo, setSubTitulo] = useState('Identificación de la persona que presenta el reclamo') 
    const [sexo, setSexo] = React.useState('');
    const [region, setRegion] = React.useState('');
    const [comuna, setComuna] = React.useState('');


    return (


    <>
        {/* aca va el sub titulo del formulario */}
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
        </Box>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        <Grid>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Rut" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Nombre" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Apellido Paterno" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Apellido Materno" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent} size="small">
           
            <InputLabel id="selectlabelGenero" variant="outlined" >Género</InputLabel>
            <Select
                labelId="generolabel"
                id="selectlabelGenero"
                variant="outlined"
                value={genero}
                label="Género"
                onChange={handleChangeGenero}
            >
            <MenuItem value={"Femenino"}>Femenino</MenuItem>
            <MenuItem value={"Masculino"}>Masculino</MenuItem>
            <MenuItem value={"Otro"}>Otro</MenuItem>
            </Select>
         </FormControl>


         <FormControl className={classes.formControlComponent} size="small">
                <InputLabel id="selectlabelSexo" variant="outlined" >Sexo</InputLabel>
                <Select
                    labelId="generoSexo"
                    id="selectlabelSexo"
                    variant="outlined"
                    value={sexo}
                    label="Sexo"
                    onChange={handleChangeSexo}
                >
                <MenuItem value={"Femenino"}>Femenino</MenuItem>
                <MenuItem value={"Masculino"}>Masculino</MenuItem>
                <MenuItem value={"Otro"}>Otro</MenuItem>
                </Select>
          </FormControl>

          <FormControl className={classes.formControlComponent}>
                <TextField
                      id="date"
                      label="Fecha de Nacimiento"
                      type="date"
                      variant="outlined"
                      size="small"
                      defaultValue="2022-03-10"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                />
          </FormControl>



           
          <InputLabel id="selectlabelAseguradora" variant="outlined" >Aseguradora</InputLabel>
          <Select
            required
            labelId="aseguradoralabel"
            id="selectlabelAseguradora"
            variant="outlined"
            value={aseguradora}
            label="Aseguradora"
            onChange={handleChange}
          >
          <MenuItem value={"fonasa"}>FONASA</MenuItem>
          <MenuItem value={"alemanasalud"}>Alemana Salud S.A.</MenuItem>
          <MenuItem value={"banmedica"}>Banmédica S.A.</MenuItem>
          </Select>


          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Correo" size="small" />   
          </FormControl>
        
          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Telefono" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}  size="small">
            <InputLabel id="selectlabel"  variant="outlined" >Región</InputLabel>
                <Select
                required
                labelId="regionlabel"
                id="regionselect"
                variant="outlined"
                value={region}
                label="Región"
                onChange={handleChangeRegion}
                >
                    <MenuItem value={0}>Seleccione</MenuItem>
                    <MenuItem value={1}>I Región de Tarapacá</MenuItem>
                    <MenuItem value={2}>II Región de Antofagasta</MenuItem>
                    <MenuItem value={3}>III Región de Atacama</MenuItem>
                </Select>

          </FormControl>
  


          <FormControl className={classes.formControlComponent}  size="small">
          <InputLabel id="selectlabel"  variant="outlined" >Comuna</InputLabel>
                <Select
                required
                labelId="comunalabel"
                id="comunaselect"
                variant="outlined"
                value={comuna}
                label="Comuna"
                onChange={handleChangeComuna}
                >
                    <MenuItem value={0}>Seleccione</MenuItem>
                    <MenuItem value={1}>Tarapacá</MenuItem>
                    <MenuItem value={2}>Antofagasta</MenuItem>
                    <MenuItem value={3}>Atacama</MenuItem>
                </Select>

          </FormControl>



        <FormControl className={classes.formControlComponent}>
          <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Dirección"  size="small"/>
        </FormControl>


         





          
        
  
       <FormControl className={classes.formControlComponent} size="small"></FormControl>
          </Grid>
      </>



  )
}

export default PasoUnoForm